import React from 'react';
import {useAppSelector} from "../../hooks/hooks";
import {Main} from "../../layouts";
import Container from "../../components/Container";
import {Box, Typography} from "@mui/material";
import BookingOverview from "../../components/vanliferComponents/BookingOverview";
import {alpha, useTheme} from "@mui/material/styles";

function BookingOverviewPage() {
    const theme = useTheme();
    const mode = theme.palette.mode;
    const userSpecificationId = useAppSelector(state => state.user.userSpecificationId)

    return (
        <Main>
            <Container>
                <React.Fragment>
                    <Typography
                        sx={{
                            textTransform: 'uppercase',
                            fontWeight: 500,
                            letterSpacing: 1,
                        }}
                        gutterBottom
                        color="text.secondary"
                    >
                        Reiseplaner
                    </Typography>

                    <Box mb={2}>
                        <Typography
                            variant="h3"
                            component="h2"
                            color="text.primary"
                            fontWeight={700}
                            lineHeight={1.2}
                        >
                            Hier siehst Du {' '}
                            <Typography
                                component="span"
                                variant="inherit"
                                color="text.primary"
                                sx={{
                                    background: `linear-gradient(180deg, transparent 82%, ${alpha(
                                        mode === 'light'
                                            ? theme.palette.secondary.main
                                            : theme.palette.primary.main,
                                        0.3
                                    )} 0%)`,
                                }}
                            >
                                alle Deine Reisen an einem Ort
                            </Typography>
                        </Typography>
                        <Box mb={3}>
                            <Typography variant="h6" color="text.secondary">
                                Schau dir an welche Reisen Du bald antreten wirst. Du kannst auch vergangene Reisen anschauen oder vorhandene Reisen bearbeiten.
                            </Typography>
                        </Box>
                    </Box>
                </React.Fragment>
                <BookingOverview  userSpecificationId={userSpecificationId} />
            </Container>
        </Main>
    );
}

export default BookingOverviewPage;